(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('sv')) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const translate = () => {
    root.querySelectorAll('.kaching-bundles__bar-variants').forEach(group => {
      const walker = document.createTreeWalker(group, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script, style, option')) continue;
        if (/\bSize\b/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\bSize\b/g, 'Storlek');
      }
      group.querySelectorAll('select[aria-label="Size"]').forEach(select => select.setAttribute('aria-label', 'Storlek'));
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; translate(); });
  }).observe(root, { childList: true, subtree: true, characterData: true });
  translate();
})();
